import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Button,
  Box,
  Menu,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Card,
  CardContent,
  Breadcrumbs,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  Paper,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Dialog,
  DialogContent,
  InputAdornment,
  Switch,
  TableSortLabel,
  Grid,
  Autocomplete,
} from "@mui/material";
import NavBar from "./NavBar";
import { toast, ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { useTheme } from "@emotion/react";
import { BUTTON_STYLES } from "../styles/componentStyles";
import api from "../axiosInstance";
import useMessage from "../hooks/useMessage";
import FilterBar from "./Reusable/FilterBar";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
import ChatRoom from "./ChatRoom";
// Column config and visibility state
const allColumns = [
  {
    key: "id",
    label: "ID",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.id,
  },

  {
    key: "conversationId",
    label: "Conversation Id",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.conversationId,
  },
  {
    key: "senderId",
    label: "Sender Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.senderId,
  },
  {
    key: "universityId",
    label: "University Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.universityId,
  },
  {
    key: "collegeId",
    label: "College Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.collegeId,
  },
  {
    key: "courseId",
    label: "Course Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.courseId,
  },
  {
    key: "semesterId",
    label: "Semester Id",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.semesterId,
  },
  {
    key: "regulationYearId",
    label: "RegulationYear Id",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.regulationYearId,
  },

  {
    key: "bookTitle",
    label: "Book Title",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.bookTitle,
  },
  {
    key: "content",
    label: "Content",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.content,
  },

  {
    key: "senderName",
    label: "Sender Name",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.senderName,
  },
  {
    key: "phoneNumber",
    label: "Phone Number",
    cellCss: { align: "center", minWidth: "130px" },
    getValue: (r) => r.phoneNumber,
  },

  {
    key: "universityName",
    label: "University Name",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.universityName,
  },
  {
    key: "collegeName",
    label: "College Name",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.collegeName,
  },

  {
    key: "courseName",
    label: "Course Name",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.courseName,
  },

  {
    key: "semesterName",
    label: "Semester Name",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r.semesterName,
  },

  {
    key: "regulationName",
    label: "Regulation",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.regulationName,
  },

  {
    key: "subRegulationYear",
    label: "Sub Regulation Year",
    cellCss: { align: "center", minWidth: "160px" },
    getValue: (r) => r.subRegulationYear,
  },
  {
    key: "createdAt",
    label: "Created At",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.createdAt,
  },
  {
    key: "updatedAt",
    label: "Updated At",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.updatedAt,
  },
];
const defaultVisibleKeys = new Set([
  "conversationId",
  "bookTitle",
  "content",
  "senderName",
  "phoneNumber",
  "universityName",
  "collegeName",
  "courseName",
  "semesterName",
  "regulationName",
  "subRegulationYear",
  "universityName",
  "createdAt",
  "updatedAt",
]);

const STORAGE_KEY = "MessagesVisibleColumns";

function MessageTable() {
  const navigator = useNavigate();
  const theme = useTheme();
  const [states, setStates] = useState([]);
  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [selectedstates, setSelectedStates] = useState("1" || "");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("notify_management") || "";
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openImage, setOpenImage] = useState(null);
  const [bannerEdit, setBannerEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("asc");
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [conversationId, setConversationId] = useState("");
  const [isFiltersLoaded, setIsFiltersLoaded] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [allbooksList, setAllbooksList] = useState([]);
  const {
    universityList,
    coursesList,
    semestersList,
    regulationsList,
    BooksList,
    totalElements,
    messages,
    loading,
    error,
    setError,
  } = useMessage(
    isFiltersLoaded
      ? {
          universityId,
          regulationId,
          searchQuery,
          semesterId,
          courseId,
          conversationId,
          rowsPerPage,
          page,
        }
      : null
  );

  console.log(messages);

  // Editing page data in onclick
  //   const handleEditClick = (rowData) => {
  //     handleNewOpen();
  //     setNewsEdit(rowData);
  //   };
  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("notify_management", searchQuery);
  }, [searchQuery]);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };
  // filtered Dat ain messagess
  const filteredData = messages.filter((notify) => {
    const search = searchQuery.toLowerCase();
    return [notify.bookTitle].some((field) =>
      field?.toString().toLowerCase().includes(search)
    );
  });
  const sortedData = useMemo(() => {
    if (!BooksList) return [];

    return [...BooksList].sort((a, b) => {
      if (!orderBy) return 0;

      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string") {
        return order === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });
  }, [BooksList, orderBy, order, conversationId]);

  //Memoize query params to avoid unnecessary re-renders
  const queryParams = useMemo(
    () => ({
      universityId,
      courseId,
      regulationId,
      semesterId,
    }),
    [universityId, courseId, regulationId, semesterId]
  );
  // all books with Filters api fetching

  useEffect(() => {
    if (!isFiltersLoaded) return; // wait for saved filters to load

    setIsLoading(true);
    api
      .get("/api/v1/allBooks", { params: queryParams })
      .then((res) => setAllbooksList(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching messages";
        setError(message);
      })
      .finally(() => setIsLoading(false));
  }, [queryParams, isFiltersLoaded]);
  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
  };

  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });
  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns))
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };
  // Helper function to get content type chip styling
  const getContentTypeChip = (type) => {
    const typeConfig = {
      text: { color: "primary", label: "Text" },
      image: { color: "secondary", label: "Image" },
      video: { color: "success", label: "Video" },
      link: { color: "info", label: "Link" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };
  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  //   // pagenation code
  const paginatedmessages = messages.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  // Columns Field showing obeject
  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));
  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpenNew(false);
  };
  // Delete The Messages
  const handleDelete = async () => {
    try {
      await api.delete(`/chatroom/messages/${selectedId}`);

      // If deletion is successful, update local state update
      //   ((prev) => prev.filter((row) => row.id !== selectedId));
      toast.success("Record deleted successfully.!", {
        position: "top-right",
        autoClose: 3000,
      });
      setOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete the record. Please try again.");
    }
  };

  const handleChange = (event) => {
    setSelectedStates(event.target.value);
  };

  //   // Notify me users data get api fetching
  //   useEffect(() => {
  //     setIsLoading(true);
  //     api
  //       .get(`/getAllMessages`, {
  //         params: { page, size: rowsPerPage, search: searchQuery },
  //       })
  //       .then((res) => {
  //         console.log(res.data.data);
  //         const data = res.data;
  //         console.log(data.data.totalElements);

  //         setNotifcation(data.data.content);
  //         setTotalElements(
  //           typeof data.data.totalElements === "number"
  //             ? data.data.totalElements
  //             : 0
  //         );
  //         setError(null);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setError(error);
  //       })
  //       .finally(() => setIsLoading(false));
  //   }, [rowsPerPage, page, searchQuery]);

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    const normalized = value === true || value === "true" || value === "Yes";
    return (
      <Chip
        label={normalized ? "Yes" : "No"}
        color={normalized ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  //  Load saved filters AFTER lists are loaded
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("messageFilters"));
    if (savedFilters) {
      setUniversityId(savedFilters.universityId || "");
      setCourseId(savedFilters.courseId || "");
      setSemesterId(savedFilters.semesterId || "");
      setRegulationId(savedFilters.regulationId || "");
      setConversationId(savedFilters.conversationId || "");
    }
    setIsFiltersLoaded(true);
  }, []);

  //  Save filters whenever any change happens
  useEffect(() => {
    if (!isFiltersLoaded) return;
    const filtersToSave = {
      universityId,
      courseId,
      semesterId,
      regulationId,
      conversationId,
    };
    localStorage.setItem("messageFilters", JSON.stringify(filtersToSave));
  }, [
    universityId,
    courseId,
    semesterId,
    regulationId,
    conversationId,
    isFiltersLoaded,
  ]);
  // reset the Local saved filters
  const [rotating, setRotating] = useState(false);
  const handleResetFilters = () => {
    setUniversityId("");
    setCourseId("");
    setSemesterId("");
    setRegulationId("");
    setConversationId("");
    localStorage.removeItem("messageFilters");
  };
  const handleClick = () => {
    setRotating(true);
    handleResetFilters?.();

    // Stop rotation after animation completes
    setTimeout(() => setRotating(false), 600); // match animation duration
  };
  //   console.log(BooksList);
  useEffect(() => {
    if (!isFiltersLoaded) return;
    if (BooksList && Array.isArray(BooksList) && BooksList.length === 0) {
      if (!universityId && !courseId && !semesterId && !regulationId) {
        setConversationId("");
      }
    }
  }, [BooksList, isFiltersLoaded]);

  const PageName = "Messages";
  return (
    <>
      {/* <NavBar /> */}
      <ToastContainer />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // column on mobile, row on desktop
          justifyContent: { xs: "flex-start", md: "space-between" }, // start on mobile, space-between on desktop
          alignItems: { xs: "stretch", md: "center" }, // stretch on mobile, center on desktop
          gap: { xs: 1, md: 0 }, // spacing between items
          mb: 2,
          marginLeft: "10px",
          marginTop: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Messages Management
          </Typography>
        </Breadcrumbs>
        <Box>
          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            useFlexGap
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 1,
              flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
              mt: { xs: 1, md: 0 },
              marginRight: "10px",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<ViewColumnIcon />}
              onClick={handleOpenColumnsMenu}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Columns
            </Button>
            <Menu
              anchorEl={columnsMenuAnchor}
              open={openColumnsMenu}
              onClose={handleCloseColumnsMenu}
              PaperProps={{
                sx: {
                  width: 200,
                  maxHeight: 500,
                  overflowY: "auto",
                  borderRadius: 2,
                },
              }}
            >
              {allColumns.map((col) => (
                <FormControlLabel
                  key={col.key}
                  control={
                    <Checkbox
                      checked={visibleColumns.has(col.key)}
                      onChange={() => toggleColumn(col.key)}
                    />
                  }
                  label={col.label}
                  sx={{ pl: 1, pr: 2 }}
                />
              ))}
            </Menu>
            {/* <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleNewOpen}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Add messagess
            </Button> */}
          </Stack>
        </Box>
      </Box>
      {/* Search Section */}
      <Card
        sx={{
          margin: { xs: "0 8px", md: "0 14px" },
          boxShadow: 1,
        }}
      >
        <CardContent
          sx={{ padding: "0px 10px", paddingBottom: "0px !important" }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              {/* === Left Filters Section === */}
              <Grid item xs={12} md={10}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    alignItems: "center",
                    margin: "0px",
                    padding: "20px 10px",
                  }}
                >
                  <FilterBar
                    universityId={universityId}
                    courseId={courseId}
                    semesterId={semesterId}
                    regulationId={regulationId}
                    setUniversityId={setUniversityId}
                    setCourseId={setCourseId}
                    setSemesterId={setSemesterId}
                    setRegulationId={setRegulationId}
                    pageName={PageName}
                  />

                  {/* Books */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    sx={{
                      paddingTop: { md: "0px !important", xs: "10px" },
                      paddingLeft: {
                        md: "16px !important",
                        xs: "0px !important",
                      },
                    }}
                  >
                    <FormControl fullWidth size="small">
                      <Autocomplete
                        size="small"
                        fullWidth
                        sx={{
                          width: { xs: "100%", md: "100%" },
                          mb: { xs: "10px", md: 0 },
                          backgroundColor: "#fff",
                        }}
                        options={
                          allbooksList.filter(
                            (v, i, a) =>
                              a.findIndex(
                                (t) => t.id === v.id && t.title === v.title
                              ) === i
                          ) || []
                        } // removes duplicates
                        // getOptionLabel={(option) =>
                        //   option?.id && option?.title
                        //     ? `${option.id} - ${option.title}`
                        //     : ""
                        // }
                        getOptionLabel={(option) =>
                          option?.id && option?.title
                            ? `${option.id} - ${option.title}`
                            : ""
                        }
                        value={
                          allbooksList.find((u) => u.id === conversationId) ||
                          null
                        }
                        onChange={(event, newValue) => {
                          setConversationId(newValue?.id || "");
                        }}
                        filterOptions={(options, { inputValue }) =>
                          options.filter(
                            (option) =>
                              option.id
                                ?.toString()
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              option.title
                                ?.toLowerCase()
                                .includes(inputValue.toLowerCase())
                          )
                        }
                        renderOption={(props, option, index) => (
                          <li
                            {...props}
                            key={`${option.id}-${option.id || index}`}
                          >
                            {option.id} - {option.title}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Book "
                            variant="outlined"
                            placeholder="Search Book ..."
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {isLoading && (
                                    <CircularProgress
                                      size={20}
                                      sx={{ mr: 2 }}
                                    />
                                  )}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              {/* === Right Side Toggle === */}
              <Grid
                item
                xs={12}
                md={2}
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Button
                    onClick={handleClick}
                    variant="outlined"
                    sx={{
                      minWidth: "20px",
                      padding: "4px 4px",
                      borderRadius: "10px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: "#17479e",
                      borderColor: "#17479e",
                      backgroundColor: "#f8f9ff",
                      transition: "all 0.3s ease",
                      boxShadow: "0 0 0 rgba(0,0,0,0)",
                      "&:hover": {
                        backgroundColor: "#17479e",
                        color: "#fff",
                        borderColor: "#17479e",
                        transform: "scale(1.05)",
                        boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                      },
                      "&:active": {
                        transform: "scale(0.98)",
                      },
                    }}
                  >
                    <RefreshIcon
                      sx={{
                        animation: rotating ? "spin 0.6s linear" : "none",
                        "@keyframes spin": {
                          "0%": { transform: "rotate(0deg)" },
                          "100%": { transform: "rotate(360deg)" },
                        },
                      }}
                    />
                  </Button>
                  <Button
                    onClick={handleNewOpen}
                    variant="outlined"
                    sx={{
                      marginLeft: "5px",
                      minWidth: "20px",
                      padding: "4px 4px",
                      borderRadius: "5px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: "#17479e",
                      borderColor: "#17479e",
                      backgroundColor: "#f8f9ff",
                      transition: "all 0.3s ease",
                      boxShadow: "0 0 0 rgba(0,0,0,0)",
                      "&:hover": {
                        backgroundColor: "#17479e",
                        color: "#fff",
                        borderColor: "#17479e",
                        transform: "scale(1.05)",
                        boxShadow: "0 3px 10px rgba(130, 188, 247, 0.3)",
                      },
                      "&:active": {
                        transform: "scale(0.98)",
                      },
                    }}
                  >
                    <QuestionAnswerRoundedIcon />
                  </Button>
                </Box>
                <Tooltip title="Dense padding" arrow>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={dense}
                        onChange={handleChangeDense}
                        color="primary"
                      />
                    }
                  />
                </Tooltip>
              </Grid>
              <Typography
                sx={{
                  display: { xs: "none", md: "block" },
                  marginLeft: "20px",
                }}
                variant="body2"
                color="text.secondary"
              >
                {sortedData.length} of {totalElements} messages items
              </Typography>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Typography
              sx={{
                display: { xs: "block", md: "none" },
                textAlign: "left",
                alignContent: "center",
              }}
              variant="body2"
              color="text.secondary"
            >
              {sortedData.length} of {totalElements} messages items
            </Typography>

            <Grid
              item
              xs={12}
              md={2}
              sx={{
                display: { xs: "flex", md: "none" },
                gap: 4,
              }}
            >
              <Box>
                <Button
                  onClick={handleClick}
                  variant="outlined"
                  sx={{
                    minWidth: "20px",
                    padding: "4px 4px",
                    borderRadius: "10px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: "#17479e",
                    borderColor: "#17479e",
                    backgroundColor: "#f8f9ff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                    "&:hover": {
                      backgroundColor: "#17479e",
                      color: "#fff",
                      borderColor: "#17479e",
                      transform: "scale(1.05)",
                      boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                  }}
                >
                  <RefreshIcon
                    sx={{
                      animation: rotating ? "spin 0.6s linear" : "none",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  />
                </Button>
                <Button
                  onClick={handleNewOpen}
                  variant="outlined"
                  sx={{
                    marginLeft: "5px",
                    minWidth: "20px",
                    padding: "4px 4px",
                    borderRadius: "5px",
                    fontWeight: 600,
                    textTransform: "none",
                    color: "#17479e",
                    borderColor: "#17479e",
                    backgroundColor: "#f8f9ff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                    "&:hover": {
                      backgroundColor: "#17479e",
                      color: "#fff",
                      borderColor: "#17479e",
                      transform: "scale(1.05)",
                      boxShadow: "0 3px 10px rgba(130, 188, 247, 0.3)",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                  }}
                >
                  <QuestionAnswerRoundedIcon />
                </Button>
              </Box>
              <Tooltip title="Dense padding" arrow>
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {!loading && (
        <Fade in={!loading}>
          <Paper
            sx={{
              width: "98%",
              mx: "auto",
              overflow: "hidden",
              boxShadow: 2,
              marginBottom: "20px",
            }}
          >
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                stickyHeader
                aria-label="news table"
                size={dense ? "small" : "medium"}
              >
                <TableHead>
                  <TableRow>
                    {visibleColumnDefs.map((c) => (
                      <TableCell
                        key={c.key}
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          ...c.cellCss,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                        sortDirection={orderBy === c.key ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === c.key}
                          direction={orderBy === c.key ? order : "asc"}
                          onClick={() => handleSort(c.key)}
                          sx={{
                            color: "#ffffff !important",
                            "&.Mui-active": {
                              color: "#ffffff !important",
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#ffffff !important",
                            },
                          }}
                        >
                          {c.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        fontWeight: 600,
                        minWidth: 120,
                        textAlign: "center",
                        position: "sticky",
                        top: 0,
                        right: 0,
                        zIndex: 4,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(sortedData) && sortedData.length > 0 ? (
                    sortedData
                      .filter((notify) => {
                        const search = searchQuery.toLowerCase();

                        return [
                          notify.universityName,
                          notify.courseName,
                          notify.semesterName,
                          notify.regulationName,
                        ].some((field) =>
                          field?.toString().toLowerCase().includes(search)
                        );
                      })
                      .map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "rgba(0, 0, 0, 0.02)",
                            },
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          {visibleColumnDefs.map((c) => (
                            <TableCell
                              key={c.key}
                              sx={{ padding: "10px 10px", ...c.cellCss }}
                            >
                              {(() => {
                                const value = c.getValue(row);
                                const key = c.key;

                                // Optional debug

                                if (key === "active" || key === "isNational") {
                                  return getBooleanChip(value);
                                }

                                if (key === "contentType") {
                                  return getContentTypeChip(value);
                                }

                                return value;
                              })()}
                            </TableCell>
                          ))}
                          <TableCell
                            sx={{
                              align: "center",
                              padding: "10px 10px",
                              minWidth: "120px",
                              position: "sticky",
                              right: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={0.5}
                              justifyContent="center"
                            >
                              {/* <Tooltip
                                      title="Edit Banner"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="primary"
                                        onClick={() => handleEditClick(row)}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "primary.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip> */}
                              <Tooltip
                                title="Delete Message"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  color="error"
                                  onClick={() => handleClickOpen(row.id)}
                                  size="small"
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "error.light",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnDefs.length + 1}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            {searchQuery
                              ? "No Messages found matching your search"
                              : "No Messages available"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              onClick={() => setSearchQuery("")}
                              startIcon={<SearchIcon />}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 50, 100]}
              component="div"
              count={totalElements}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                "& .MuiTablePagination-toolbar": {
                  paddingLeft: 2,
                  paddingRight: 2,
                },
              }}
            />
          </Paper>
        </Fade>
      )}
      {/* Confirm Delete Dialog */}
      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this news item? This action cannot be undone."
        confirmText="DELETE"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />

      <ChatRoom messages={messages} openNew={openNew} onClose={handleClose} />
    </>
  );
}

export default MessageTable;
